import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import "../Assets/Css/HomeCss/DoctorBlog.css";
import FooterTopBar from "../Components/FooterTopBar";
import { Footer, Header } from "../Components";
import { fetchBlogsPage, formatBlogDate } from '../Services/BlogService';

const PER_PAGE = 9;

const DoctorBlog = () => {
  document.title = "Healthy Articles - Famra Cure";

  const [blogs, setBlogs] = useState([]);
  const [page, setPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");

  const loadPage = (pageToLoad) => {
    setIsLoading(true);
    setError("");
    fetchBlogsPage(pageToLoad, PER_PAGE)
      .then((result) => {
        if (!result || !Array.isArray(result.data)) throw new Error("Unexpected response");
        setBlogs((prev) => (pageToLoad === 1 ? result.data : [...prev, ...result.data]));
        setPage(result.current_page);
        setLastPage(result.last_page);
      })
      .catch((err) => {
        console.log(err);
        setError("Could not load articles. Please try again.");
      })
      .finally(() => setIsLoading(false));
  };

  useEffect(() => {
    loadPage(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Header />
      <div className="blog-banner">
        <div className="blog-banner-content">
          <h1>Healthy Articles</h1>
          <p>Practical health tips and guidance from our medical experts</p>
        </div>
      </div>

      <main className="blog-list">
        <div className="blog-container">
          {blogs.map((blog) => (
            <Link key={blog.id} to={`/blog/${blog.slug}`} className="blog-card">
              <div className="blog-card-image-wrap">
                <img src={blog.image_url || "/img/blog1.png"} alt={blog.title} className="blog-card-image" loading="lazy" />
              </div>
              <div className="blog-card-content">
                {blog.published_at && (
                  <p className="blog-card-date">{formatBlogDate(blog.published_at)}</p>
                )}
                <h2 className="blog-card-title">{blog.title}</h2>
                {blog.summary && <p className="blog-card-summary">{blog.summary}</p>}
                <span className="blog-card-link">Read article →</span>
              </div>
            </Link>
          ))}

          {isLoading && [1, 2, 3].map((n) => (
            <div key={`skeleton-${n}`} className="blog-card" aria-hidden="true">
              <div className="blog-card-image-wrap bg-gray-200 animate-pulse"></div>
              <div className="blog-card-content space-y-3">
                <div className="h-3 w-1/3 rounded bg-gray-200 animate-pulse"></div>
                <div className="h-5 w-3/4 rounded bg-gray-200 animate-pulse"></div>
                <div className="h-4 w-full rounded bg-gray-200 animate-pulse"></div>
              </div>
            </div>
          ))}
        </div>

        {!isLoading && !error && blogs.length === 0 && (
          <p className="blog-empty">No articles have been published yet. Please check back soon.</p>
        )}

        {error && (
          <div className="blog-empty">
            <p className="text-red-600 mb-3">{error}</p>
            <button type="button" className="blog-load-more" onClick={() => loadPage(1)}>Try again</button>
          </div>
        )}

        {!isLoading && !error && page < lastPage && (
          <div className="text-center">
            <button type="button" className="blog-load-more" onClick={() => loadPage(page + 1)}>
              Load more articles
            </button>
          </div>
        )}
      </main>
      <FooterTopBar />
      <Footer />
    </>
  );
};

export default DoctorBlog;
